import AbstractSubscriptionForm from "./AbstractSubscriptionForm";
import { LOADER_CONFIG } from "../assets/_loaderConfig";

const SUBSCRIBE_INPUT_CLIENT_ID_CLASS = "js-subscribe-input-client_id";
const SUBSCRIBE_INPUT_EMAIL = "js-subscribe-input-email";
const SUBSCRIBE_INPUT_MAILING = "js-subscribe-input-mailing";
const SUBSCRIBE_BUTTON_CLASS = "js-subscribe-btn";

/**
 * Форма подписки на рассылку на странице subscribe page
 */
export default class SubscribePageForm extends AbstractSubscriptionForm {
    constructor(formElem) {
        super(formElem);
        this.url = LOADER_CONFIG.api_subscribe.url;

        if (formElem.classList.contains("resubscribe")) {
            this._isSomeSubscriptionChecked = true;
            this._isEmailValid = true;

            this._btnElem.disabled = this._isButtonDisabled();
        }
    }

    _setElems() {
        this._inputClientIdElem = this.elem.querySelector(`.${SUBSCRIBE_INPUT_CLIENT_ID_CLASS}`);
        this._inputEmailElem = this.elem.querySelector(`.${SUBSCRIBE_INPUT_EMAIL}`);
        this._inputSubscribeMailings = this.elem.querySelectorAll(`.${SUBSCRIBE_INPUT_MAILING}`);
        this._btnElem = this.elem.querySelector(`.${SUBSCRIBE_BUTTON_CLASS}`);

        if (this.elem.classList.contains("resubscribe")) {
            this._btnElem.disabled = true;
        }
    }

    _getBody() {
        const body = {
            client_id: this._inputClientIdElem.value,
            mailing_ids: [...this._inputSubscribeMailings]
                .filter((item) => item.checked)
                .map((item) => item.id),
        };

        if (this.elem.classList.contains("resubscribe")) {
            body.email = this._inputEmailElem.value;
        }

        return body;
    }

    _toggleDisable(isDisable = true) {
        this._btnElem.disabled = isDisable;
        this._inputSubscribeMailings.forEach(input => input.disabled = isDisable);
    }

    // проверка корректности введенного email для формы REsubscribe
    _setEmailInputHandler() {
        const EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        this._inputEmailElem.addEventListener("input", () => {
            this._isEmailValid = EMAIL_REGEXP.test(this._inputEmailElem.value);
            this._updateButtonState();
        });
    }

    // проверка на отмеченность хотя бы одного чекбокса для формы REsubscribe
    _setSubscribeMailingsHandler() {
        this._inputSubscribeMailings.forEach(input => {
            input.addEventListener("change", () => {
                this._isSomeSubscriptionChecked = [...this._inputSubscribeMailings].some(item => item.checked);
                this._updateButtonState();
            });
        });
    }

    _updateButtonState() {
        this._btnElem.disabled = this._isButtonDisabled();
    }

    _isButtonDisabled() {
        if (this.elem.classList.contains("resubscribe")) {
            return !(this._isSomeSubscriptionChecked && this._isEmailValid);
        }

        return false;
    }

    _setHandlers() {
        super._setHandlers();

        if (this.elem.classList.contains("resubscribe")) {
            this._setEmailInputHandler();
            this._setSubscribeMailingsHandler();
        }
    }

    _reset() {}
}
